import React from "react";
import StatusPill from "@/components/StatusPill";
import { Banknote, Calendar, MapPin } from "lucide-react";

export default function TaskHeaderCard({ task }) {
  return (
    <div className="lg:col-span-12 eb-card p-6 md:p-8 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-80 h-80 rounded-full bg-[var(--eb-primary)] opacity-10 blur-3xl" />
      <div className="relative flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--eb-text-dim)]">
            {task.category_label} · {task.task_id}
          </div>
          <h1 className="mt-2 text-3xl md:text-4xl">{task.title}</h1>
          <div className="mt-3 flex flex-wrap gap-3 items-center text-sm text-[var(--eb-text-dim)]">
            <StatusPill status={task.status} />
            <span className="inline-flex items-center gap-1">
              <MapPin className="w-3.5 h-3.5" /> {task.city}
            </span>
            {task.budget_ngn ? (
              <span className="inline-flex items-center gap-1">
                <Banknote className="w-3.5 h-3.5" /> ₦{task.budget_ngn.toLocaleString()}
              </span>
            ) : null}
            {task.deadline ? (
              <span className="inline-flex items-center gap-1">
                <Calendar className="w-3.5 h-3.5" /> {new Date(task.deadline).toLocaleString()}
              </span>
            ) : null}
          </div>
          <p className="mt-4 text-[var(--eb-text)] max-w-3xl">{task.description}</p>
          {task.special_instructions && (
            <p className="mt-2 text-sm text-[var(--eb-text-dim)] italic">&quot;{task.special_instructions}&quot;</p>
          )}
        </div>
        <div className="text-right">
          <div className="text-xs uppercase tracking-[0.18em] text-[var(--eb-text-dim)]">Agent</div>
          <div className="mt-1 font-[800] text-lg">{task.agent_name || "Awaiting assignment"}</div>
          <div className="text-xs text-[var(--eb-text-dim)]">Client: {task.client_name}</div>
        </div>
      </div>
    </div>
  );
}
